<div class="mini-cart-container">
  <a [routerLink]="{ cxRoute: 'cart' } | cxUrl" rel="noreferrer noopener">
    <mat-icon
      matTooltip="{{ 'buttonTooltip.minicart.title' | cxTranslate }}"
      [matTooltipPosition]="'below'"
      matTooltipClass="icon-tooltip"
      aria-label="displays a tooltip in bottom"
      class="material-icons-sharp light"
      [class.is-badge-loading]="this.isCartLoading"
      [matBadgeHidden]="(quantity$ | async) === 0 && !this.isCartLoading"
      [matBadge]="this.isCartLoading ? '' : (quantity$ | async) <= 99 ? (quantity$ | async) : '99+'"
      matBadgeSize="small"
      matBadge
      [matTooltipDisabled]="deviceDetectorService.isMobile() || deviceDetectorService.isTablet()"
      >shopping_cart</mat-icon
    >
  </a>
</div>
